/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Choice_Page_SubtitleInputs */

const fr_plan_choice_page_subtitle = /** @type {(inputs: Plan_Choice_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez votre formule, le paiement se fait ensuite de façon sécurisée avec Stripe.`)
};

/**

* @param {Plan_Choice_Page_SubtitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plan_choice_page_subtitle = /** @type {((inputs?: Plan_Choice_Page_SubtitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choice_Page_SubtitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plan_choice_page_subtitle(inputs)
});